import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AssessmentsGuide from "./AssessmentsGuide";
import classes from './Guide.module.css'
import { usersApi } from "../../../../utils";
import { throwApiError } from "../../../lms-shared/store/error-handling-actions";
import { UserActivityEnum } from "../../../../models/UserActivityEnum";
import Permissions from "../../../Permissions";
import Loader from "../../../UI/Loader";
import SearchApi from "../../../lms-shared/UI/SearchApi";
import { SelectBtnStyle, SelectOption } from "../../../lms-shared/UI/SelectBtnStyle";


const Guide = () => {

    const texts = useSelector((state) => state.translate.texts);
    const [showSearch, setShowSearch] = useState(true)
    const [showLoader, setShowLoader] = useState(false)
    const { applicationId } = useSelector(state => state.application);
    const dispatch = useDispatch();

    const [searchGuideList, setSearchGuideList] = useState({
        school: {
            inputValue: '',
            listSelect: null,
        },
        teacher: {
            inputValue: texts.chooseTeacher,
            listSelect: null,
            teacherId: null,
            teacherName: null
        },
    })

    function fetchSchoolApi(value) {
        setSearchGuideList(prev => ({ ...prev, teacher: { ...prev.teacher, listSelect: null, inputValue: texts.chooseTeacher } }))
        setShowLoader(true)
        usersApi.usersSearchSchoolsPost({ searchStr: value ? value : searchGuideList.school.inputValue }, (error, resdata, response) => {
            setShowLoader(false)
            if (error) {
                dispatch(throwApiError({ userMessage: texts.submissionsRandomRangeFilterError, error: error, statusCode: response?.statusCode, message: "submissionsRandomRangeFilter " + error.message, level: 2, component: "AssessmentsGuide", line: 141 }))
            }
            else {
                setSearchGuideList(prev => ({
                    ...prev,
                    school: {
                        ...prev.school,
                        listSelect: response.body.length > 0 ? [...response.body] : [{ id: -1, name: texts.noResultsFound }],
                    },
                    teacher: {
                        ...prev.teacher,
                        listSelect: null,
                        inputValue: texts.chooseTeacher
                    }
                }))
            }
        })
    }

    function fetchTeacherApi(id) {
        const data = {
            applicationId: applicationId,
            schoolId: id
        }
        setShowLoader(true)
        usersApi.usersFilterTeachersRangePost({ teachersRangeFilter: data }, (error, resdata, response) => {
            setShowLoader(false)
            if (error) {
                dispatch(throwApiError({ userMessage: texts.submissionsRandomRangeFilterError, error: error, statusCode: response?.statusCode, message: "submissionsRandomRangeFilter " + error.message, level: 2, component: "AssessmentsGuide", line: 141 }))
            }
            else {
                setSearchGuideList(prev => ({
                    ...prev,
                    teacher: {
                        ...prev.teacher,
                        listSelect: response.body
                    }
                }))
            }
        })
    }

    const changeSearchText = (value) => {
        fetchSchoolApi(value)
    }

    function onClickIcon(e) {
        e.stopPropagation();
        setSearchGuideList(prev => ({ ...prev, teacher: { ...prev.teacher, listSelect: null } }))
        fetchSchoolApi()
    }

    function selectItemClick(value) {
        setSearchGuideList(prev => ({ ...prev, school: { ...prev.school, inputValue: (value?.id || "") + " " + (value?.name || '') + (value?.cityName ? (", " + value.cityName) : ''), listSelect: [], } }))
        fetchTeacherApi(value.id)
    }

    const changeOption = (name, value) => {
        setSearchGuideList(prev => ({ ...prev, teacher: { ...prev.teacher, inputValue: value.name, teacherId: value.id, teacherName: value.name } }))
        setShowSearch(false)
    }

    const changeInputValue = (value) => {
        setSearchGuideList(prev => ({ ...prev, school: { ...prev.school, inputValue: value, listSelect: null }, teacher: { ...prev.teacher, inputValue: value, listSelect: null } }))
    }

    const changeListSelect = (value) => {
        setSearchGuideList(prev => ({ ...prev, school: { ...prev.school, listSelect: value } }))
    }

    return (
        <Permissions activityType={UserActivityEnum.LearningSupervision} cancelAction={true}>
            <div className={classes.GuideContainer}>

                {showSearch ?
                    <div className={classes.SearchBtnsContainer}>
                        <SearchApi
                            onClickIcon={onClickIcon}
                            changeSearchText={changeSearchText}
                            inputPlaceholder={texts.chooseSchool}
                            inputValue={searchGuideList.school.inputValue}
                            setInputValue={changeInputValue}
                            listSelect={searchGuideList.school.listSelect}
                            setListSelect={changeListSelect}
                            selectItemClick={selectItemClick}
                            showListByParams={['id', 'name', 'cityName']}
                        />

                        {searchGuideList.teacher.listSelect &&
                            <SelectBtnStyle onChange={changeOption} value={searchGuideList.teacher.inputValue} name="Teacher">
                                {searchGuideList.teacher.listSelect.map(item =>
                                    <SelectOption key={item.id} value={{ id: item.id, name: item.firstName + " " + item.lastName }} >{item?.firstName + " " + item?.lastName}</SelectOption>
                                )}
                            </SelectBtnStyle>}
                    </div>
                    :
                    <AssessmentsGuide teacherId={searchGuideList.teacher.teacherId} teacherName={searchGuideList.teacher.teacherName} setShowSearch={setShowSearch}></AssessmentsGuide>
                }
                {showLoader && <Loader></Loader>}
            </div>
        </Permissions >
    )

}

export default Guide;